(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nuoneo-navigation-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => document.querySelectorAll('m-header').forEach(header => {
    if (header.dataset.nnInitialized || !header.querySelector('[data-nn-navigation]')) return;
    header.dataset.nnInitialized = 'true';
    const desktop = matchMedia('(min-width: 1024px)');
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    const disclosures = [...header.querySelectorAll('.nn-nav__disclosure')];
    const needDisclosures = [...header.querySelectorAll('.nn-nav__need')];
    const drawer = header.querySelector('#m-menu-drawer');
    const hamburger = header.querySelector('.m-hamburger-box');
    const mobileHeader = header.querySelector('.m-header__mobile');
    let wasOpen = false;
    let savedScroll = 0;
    const measure = () => {
      const desktopHeader = header.querySelector('.m-header__desktop');
      const bottom = (desktop.matches ? desktopHeader : mobileHeader).getBoundingClientRect().bottom;
      header.style.setProperty('--nn-panel-height', Math.max(100, innerHeight - bottom - 20) + 'px');
      if (!desktop.matches) drawer.style.setProperty('--menu-drawer-height', Math.max(80, (visualViewport?.height || innerHeight) - bottom) + 'px');
    };
    const update = () => {
      header.classList.toggle('nn-navigation-open', disclosures.some(d => d.open && d.closest('[data-nn-navigation="desktop"]')));
      measure();
    };
    const closeDesktop = () => {
      disclosures.filter(d => d.closest('[data-nn-navigation="desktop"]')).forEach(d => d.open = false);
      update();
    };
    const closeDrawer = () => {
      if (drawer.classList.contains('open') && hamburger.classList.contains('active')) hamburger.click();
    };
    disclosures.forEach(details => {
      let timer;
      const summary = details.querySelector('summary');
      details.addEventListener('toggle', event => {
        if (event.target !== details) return;
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          disclosures.filter(d => d !== details && d.closest('nav') === details.closest('nav')).forEach(d => d.open = false);
          if (!desktop.matches) drawer.querySelector('.m-menu-drawer__content').scrollTop = 0;
        }
        update();
      });
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('pointerenter', () => {
        if (!desktop.matches || !hover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => { details.open = true; }, 120);
      });
      details.addEventListener('pointerleave', () => {
        if (!desktop.matches || !hover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 240);
      });
      summary.addEventListener('click', () => clearTimeout(timer));
    });
    needDisclosures.forEach(details => {
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        measure();
      });
    });
    header.querySelector('[data-nn-close]')?.addEventListener('click', closeDrawer);
    document.addEventListener('pointerdown', event => {
      if (!event.target.closest('.nn-nav--desktop')) closeDesktop();
    });
    document.addEventListener('focusin', event => {
      if (desktop.matches && !event.target.closest('.nn-nav--desktop')) closeDesktop();
    });
    header.addEventListener('focusout', () => {
      setTimeout(() => {
        if (desktop.matches) disclosures.forEach(d => {
          if (d.open && !d.contains(document.activeElement)) d.open = false;
        });
      });
    });
    const visibleFocusable = () => [hamburger, ...drawer.querySelectorAll('a[href],button,summary,select,input,[tabindex="0"]')].filter(el => {
      const closed = el.closest('details:not([open])');
      return (!closed || el === closed.querySelector('summary')) && !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const need = document.activeElement.closest('.nn-nav__need[open]');
        if (need && header.contains(need)) {
          event.preventDefault();
          need.open = false;
          need.querySelector('summary').focus({ preventScroll: true });
          return;
        }
        const current = disclosures.find(d => d.open && d.contains(document.activeElement));
        if (drawer.classList.contains('open')) {
          if (current) { current.open = false; current.querySelector('summary').focus(); }
          else closeDrawer();
        } else {
          closeDesktop();
          current?.querySelector('summary').focus();
        }
      }
      if (event.key === 'Tab' && drawer.classList.contains('open') && !desktop.matches) {
        const nodes = visibleFocusable();
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    const syncDrawer = () => {
      const open = drawer.classList.contains('open') && !desktop.matches;
      drawer.inert = !open;
      hamburger.setAttribute('aria-expanded', String(open));
      if (open && !wasOpen) {
        savedScroll = window.scrollY;
        document.documentElement.style.setProperty('--nn-header-top', Math.max(0, mobileHeader.getBoundingClientRect().top) + 'px');
        document.documentElement.style.setProperty('--nn-scroll-top', -savedScroll + 'px');
        document.documentElement.classList.add('nn-navigation-lock');
        closeDesktop();
        measure();
        requestAnimationFrame(() => header.querySelector('[data-nn-close]').focus({ preventScroll: true }));
      } else if (!open && wasOpen) {
        document.documentElement.classList.remove('nn-navigation-lock');
        document.documentElement.style.removeProperty('--nn-scroll-top');
        document.documentElement.style.removeProperty('--nn-header-top');
        window.scrollTo({ top: savedScroll, behavior: 'instant' });
        disclosures.forEach(d => d.open = false);
        needDisclosures.forEach(d => d.open = false);
        if (drawer.contains(document.activeElement) && !desktop.matches) hamburger.focus({ preventScroll: true });
      }
      wasOpen = open;
    };
    new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    desktop.addEventListener('change', () => { closeDesktop(); closeDrawer(); syncDrawer(); measure(); });
    window.addEventListener('resize', measure, { passive: true });
    visualViewport?.addEventListener('resize', measure, { passive: true });
    new ResizeObserver(measure).observe(mobileHeader);
    syncDrawer();
    measure();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
